module.exports = __webpack_public_path__ + "static/media/8_opium_cake.aaaa5047.jpg";